import { render, staticRenderFns } from "./lessonDetail.vue?vue&type=template&id=b37331cc&scoped=true"
import script from "./lessonDetail.vue?vue&type=script&lang=js"
export * from "./lessonDetail.vue?vue&type=script&lang=js"
import style0 from "./lessonDetail.vue?vue&type=style&index=0&id=b37331cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37331cc",
  null
  
)

export default component.exports